const teamBanners: {
  [key: string]: any;
} = {};

export default teamBanners;
